import { PLACEHOLDERS } from "./constants";
import { isEmpty } from "@swiggy-private/js-utils";

export function convertObjToString(context: unknown): string {
    try {
        return JSON.stringify(context);
    } catch (_ex) {
        return "";
    }
}

export const formatePlanAction = (action: string, isOneProgram?: string) => {
    if (isEmpty(isOneProgram)) {
        return action;
    }

    if (action.includes(PLACEHOLDERS.OFFER_BUNDLE_SEMICOLON)) {
        return String(action).replace(/offer_bundle/g, PLACEHOLDERS.AUTO_ADD_SEMICOLON);
    } else if (action.includes(PLACEHOLDERS.OFFER_BUNDLE_HYPHEN)) {
        return String(action).replace(/offer-bundle/g, PLACEHOLDERS.AUTO_ADD_HYPHEN);
    }
};

export const getCouponType = (isPaymentCouponWidget?: boolean) => {
    return isPaymentCouponWidget ? "Payment" : "Restaurant";
};
